<div class="dark text-justify scroll-box">
  <div class="info-header">
    <h4 class="info-title">{{ 'FAQ' | translate }}</h4>
  </div>
  <hr>

  <ng-container *ngIf="faqs_main.length > 0 && !isSkeletonFaqsMain; else skeletonFaqsMain">
    <div class="formtext p-1 m-t-10" [innerHTML]="sanitize(faqs_main)"></div>
  </ng-container>

  <ng-template #skeletonFaqsMain>
    <ng-container *ngIf="isSkeletonFaqsMain">
      <ng-container *ngFor="let item of [].constructor(4)">
        <p class="skeleton skeleton-text mb-1"></p>
      </ng-container>
      <p class="skeleton skeleton-text mb-3 w-75"></p>
    </ng-container>
  </ng-template>

  <ng-container *ngIf="faqsLength > 0 && !isSkeletonFaqsMain; else skeletonFaqsLength">
    <div class="container p-l-0 p-r-0">
      <div [ngClass]="{'m-b-30': faqsLength !== (i+1)}" *ngFor="let faq of faqs; let i = index">
        <div *ngIf="faq.contents.length > 0">
          <h5 class="m-b-15 m-t-15 faq-page-title">{{ faq.display_title }}</h5>
          <mat-accordion class="vip-faq" *ngIf="faq.contents !== undefined">
            <ng-container *ngFor="let item of faq.contents">
              <mat-expansion-panel class="m-b-10" (afterExpand)="scroll(item.id)" hideToggle>
                <mat-expansion-panel-header>
                  <mat-panel-title [id]="item.id">
                    <div [innerHTML]="item.question"></div>
                    <i class="icon-chevron-down dropdown-arrow-img"></i>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div [innerHTML]="item.answer.replace('&lt;p&gt;', '').replace('&lt;/p&gt;', '')"></div>
              </mat-expansion-panel>
            </ng-container>
          </mat-accordion>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template #skeletonFaqsLength>
    <ng-container *ngIf="isSkeletonFaqsMain">
      <p class="skeleton skeleton-category-title mb-3 w-25 ml-0"></p>
      <div *ngFor="let item of [].constructor(5) | slice:0:1">
        <mat-accordion class="faq-section">
          <ng-container *ngFor="let item of [].constructor(5)">
            <mat-expansion-panel class="m-b-15 border-0 skeleton-faq-mat-header">
              <mat-expansion-panel-header class="skeleton"></mat-expansion-panel-header>
            </mat-expansion-panel>
          </ng-container>
        </mat-accordion>
      </div>
    </ng-container>
  </ng-template>
</div>
